import { render } from "./BookingRibbon.vue?vue&type=template&id=7b29975c"
import script from "./BookingRibbon.vue?vue&type=script&lang=js"
export * from "./BookingRibbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingRibbon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b29975c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b29975c', __exports__)) {
    api.reload('7b29975c', __exports__)
  }
  
  module.hot.accept("./BookingRibbon.vue?vue&type=template&id=7b29975c", () => {
    api.rerender('7b29975c', render)
  })

}


export default __exports__